import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
// import {setAuthorization} from "../helpers/api_helper";
// import { useDispatch } from "react-redux";
// import { useProfile } from "../Components/Hooks/UserHooks";
// import { logoutUser } from "../store/actions";
import { useAuthContext } from "../Components/AuthContext";

const AuthProtected = (props) => {
  // const dispatch = useDispatch();
  // const { userProfile, loading, token } = useProfile();
  // useEffect(() => {
  //   if (userProfile && !loading && token) {
  //     setAuthorization(token);
  //   } else if (!userProfile && loading && !token) {
  //     dispatch(logoutUser());
  //   }
  // }, [token, userProfile, loading, dispatch]);

  const {
    userInfo, isLoading, accessToken
  } = useAuthContext();

  /*
    redirect is un-auth access protected routes via url
  */
  if ((!userInfo && !isLoading) || !accessToken) {
    return (
      <Navigate to="/login" state={{ from: props.location }} replace />
    );
  }

  return <>{props.children}</>;
};

export { AuthProtected };